/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Member,
  MemberRequest,
  MemberSearchResults,
  MembersCounts,
  MembersCountsRetrieveParams,
  MembersListParams,
  MembersSearchRetrieveParams,
  PaginatedMemberList,
  PatchedMemberRequest
} from '../types';

import { apiV2 } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const membersList = (
    params?: MembersListParams,
 options?: SecondParameter<typeof apiV2<PaginatedMemberList>>,) => {
      return apiV2<PaginatedMemberList>(
      {url: `/members/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const membersCreate = (
    memberRequest: MemberRequest,
 options?: SecondParameter<typeof apiV2<Member>>,) => {
      return apiV2<Member>(
      {url: `/members/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: memberRequest
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const membersRetrieve = (
    id: string,
 options?: SecondParameter<typeof apiV2<Member>>,) => {
      return apiV2<Member>(
      {url: `/members/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const membersUpdate = (
    id: string,
    memberRequest: MemberRequest,
 options?: SecondParameter<typeof apiV2<Member>>,) => {
      return apiV2<Member>(
      {url: `/members/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: memberRequest
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const membersPartialUpdate = (
    id: string,
    patchedMemberRequest?: PatchedMemberRequest,
 options?: SecondParameter<typeof apiV2<Member>>,) => {
      return apiV2<Member>(
      {url: `/members/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedMemberRequest
    },
      options);
    }
  /**
 * Returns counts used for sidebar/tab badges. Admin and Super Admin only. Optional ?role= narrows the unassigned set to one or more roles; omit to count across all roles.
 * @summary Member badge counts
 */
export const membersCountsRetrieve = (
    params?: MembersCountsRetrieveParams,
 options?: SecondParameter<typeof apiV2<MembersCounts>>,) => {
      return apiV2<MembersCounts>(
      {url: `/members/counts/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Results hold at most 10 members matching the term on member name, user name or user email, best match first. Intended for the Bridge header search. Count is the total number of matches the caller may see, which may exceed the 10 returned. Next and previous are always null: there are no further pages, so do not page against them. Terms shorter than 3 characters return empty results: the substring match cannot use the trigram index below 3 characters, and the matches are too broad to be useful. Terms longer than 255 characters, the width of the widest matched column, also return empty results, because beyond that the query stops using the index. Omitting the search parameter entirely is a 400, so that a wrong parameter name is not mistaken for a search with no matches. Role and status are applied before the 10-result limit and the count, so better matches of another role or status never push out the ones asked for. Discharged patients the caller may see are included, subject to the status filter. An unknown or empty role or status is a 400, even for a short term.
 * @summary Member typeahead search
 */
export const membersSearchRetrieve = (
    params: MembersSearchRetrieveParams,
 options?: SecondParameter<typeof apiV2<MemberSearchResults>>,) => {
      return apiV2<MemberSearchResults>(
      {url: `/members/search/`, method: 'GET',
        params
    },
      options);
    }
  export type MembersListResult = NonNullable<Awaited<ReturnType<typeof membersList>>>
export type MembersCreateResult = NonNullable<Awaited<ReturnType<typeof membersCreate>>>
export type MembersRetrieveResult = NonNullable<Awaited<ReturnType<typeof membersRetrieve>>>
export type MembersUpdateResult = NonNullable<Awaited<ReturnType<typeof membersUpdate>>>
export type MembersPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof membersPartialUpdate>>>
export type MembersCountsRetrieveResult = NonNullable<Awaited<ReturnType<typeof membersCountsRetrieve>>>
export type MembersSearchRetrieveResult = NonNullable<Awaited<ReturnType<typeof membersSearchRetrieve>>>
